<template>
  <div class="patentList fatherHeight contBox">
    <div class="search-top">
      <el-form :inline="true" :model="searchData" ref="searchForm" :label-width="80" label-suffix=":">
        <el-form-item label="时间">
          <el-date-picker v-model="searchData.check_date" value-format="YYYY-MM-DD" type="date" 
            />
        </el-form-item>
        <el-form-item label="">
          <el-button class="color-main" @click="resetForm" type="primary">
            <i class="fa fa-refresh"></i>重置
          </el-button>
          <el-button @click="getDataList" class="color-main" type="primary">
            <i class="fa fa-search"></i>查询
          </el-button>
          <el-button class="color-vice" type="primary" @click="exportTable(1)">
            <i class="fa fa-arrow-down"></i>导出
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <demo :excel="excel"></demo>

  </div>
</template>
<script>
  import axios from 'axios'
  import comm from '@/utils/comm'
  import demo from '@/components/demo'
  import {
    reactive,
    toRefs,
    ref,
    nextTick,
    onMounted,
    onBeforeUnmount,
  } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import service from '@/utils/request'
  import { gitDictList, gitDictVal, TimestampToTime, downLoadXlsx } from '@/utils/tool'
  import { ElMessageBox, ElMessage, ElNotification } from 'element-plus'
  export default {
    name: 'patentList',
    components: {
      demo
    },
    setup() {
      const state = reactive({
        excel: '',
        searchData: {
          check_date: '',
        },
      })

      onMounted(() => {
        state.searchData.check_date = TimestampToTime()
        console.log(state.searchData.time)
        getDataList()
      })
      const resetForm = () => {
        state.searchData.check_date = TimestampToTime()
        
        getDataList()
      }
      const getDataList = async () => {
        let url = '/api/export/exportDrugInventorySsheet'
        let port = location.protocol
        let ip = comm.cesuUrl
        let requestUrl = `${port}//${ip}${url}`
        axios({
          headers: {
            token: localStorage.getItem('ms_token'),
          },
          method: 'post',
          responseType: 'blob',
          url: requestUrl,
          data: state.searchData,
        })
          .then((res) => {
            const link = document.createElement('a')
            let blob = new Blob([res.data], {
              type: 'application/vnd.ms-excel',
            })
            state.excel = URL.createObjectURL(blob)
          })
          .catch((err) => {
            console.log(err)
          })
      }
      // 导出
      const exportTable = async (row) => {
        let url = '/api/export/exportDrugInventorySsheet'
        let title = `药品盘点单.xlsx`
        downLoadXlsx(url, state.searchData, title)
      }
      return {
        ...toRefs(state),
        resetForm,
        getDataList,
        exportTable
      }
    },
  }
</script>

<style scoped lang="scss">
  #printArea {
    /* transform: scale(0.85) translateX(-160px); */
  }
</style>